module.exports = {
    //城市控件
    cityList: "/api/Area/GetListAll",
    //产业结构
    ProfessionType: "/api/IndustrialStructure/GetListJson",
    // 招商引资
    AttractInvestment: "/api/AttractInvestment/GetListJson",
    //招商引资-招商图谱（产业链描述）下拉框接口  
    IndustrialSelect: "/api//DataDict/GetListJson?DictType=IndustrialChainType",
    //招商引资-招商图谱（产业链描述）数据
    IndustrialData: "/api/AttractInvestment/GetMyAIIndustrialChainJson",
    //企业信息
    EnterpriseData: "/api/ENTInformation/GetEnterpriseInformationList",
    //首页-市场主体
    FCapitalFlows: "/api/MarketSubject/GetMarketSubjectList",
    //资本流动
    InvestmentCategory: "/api/CapitalFlows/GetCapitalFlowsList",
    //市场主体-CRI指数
    GetCriIndexData: "/api/CriIndex/GetCriIndexList",
    //市场主体-企业总量-本地数据（图表）
    GetTotalEnterprisesDEData: "/api/TotalEnterprisesDE/GetTotalEnterprisesDEList",
    //时间类型
    TimeData: "/api/DataDict/GetListJson?DictType=TimeType",
    //指标类型
    IndicatorTypeData: "/api/DataDict/GetListJson?DictType=IndicatorType",
    //企业状态
    EnterpriseStatusData: "/api/DataDict/GetListJson?DictType=EnterpriseStatus",
    //企业注册资本状态
    CapitalStatusData: "/api/DataDict/GetListJson?DictType=CapitalStatus",
    //市场主体-企业总量-区域对比
    EnterpriseStatus: "/api/RegionComparison/GetRegionalComparisonList",
    //市场主体-重点企业
    KeyEnterprisesData: "/api/KeyEnterprises/GetRegionalComparisonList",
    //企业类别 http://101.200.237.184:8080/DataDict/GetListJson?DictType=EnterpriseTwoType
    EnterpriseTypesDiction: "/api/DataDict/GetListJson?DictType=EnterpriseTwoType",
    //市场主体-行业分析-基本概括
    GetIndustryAnalysisBasicData: "/api/BasicOverview/GetIndustryAnalysisBasicList",
    //市场主体-结构分析（线图）
    GetListAllData: "/api/SruAnalysisLine/GetListAll",
    //所有行业接口 
    GetIndustryData: "/api//BasicOverview/GetIndustryList",
    //创新发展（首页）
    GetRegionalComparisonData: "/api/InnovateFirPage/GetRegionalComparisonList",
    //行业类别接口http://101.200.237.184:8080/BasicOverview/GetIndustryList
    IndustryDiction: "/api/BasicOverview/GetIndustryList",
    //企业列表中下拉框-评分
    ScoreTypeDic: "/api/DataDict/GetListJson?DictType=ScoreType",
    //企业列表中下拉框-币种
    CurrencyDic: "/api/DataDict/GetListJson?DictType=Currency",
    //企业列表中下拉框-企业规模
    EnterpriseScaleDic: "/api/DataDict/GetListJson?DictType=EnterpriseScale",
    //企业列表中下拉框-企业类型
    EnterpriseCompanyStatusDic: "/api/DataDict/GetListJson?DictType=EnterpriseCompanyStatus",
    //企业列表中下拉框-经营状态
    OperatingStatusDic: "/api/DataDict/GetListJson?DictType=OperatingStatus",
    //创新发展-创新成果
    GetMyInnovationSubjectData: "/api/InnovationSubject/GetMyInnovationSubject",
    //创新主体-创新主体
    MyInnovativeAchievementsData: "/api/InnovativeAchievements/GetMyInnovativeAchievements",
    //开放发展-结构分析-柱图
    MyStructuralAnalysisCoDate: "/api/StructuralAnalysisCo/GetMyStructuralAnalysisCo",
    //首页-开放发展
    SDevelopmenPprog: "/api/DevelopmenPprogress/GetMyDevelopmenPprogress",
    //开放发展-结构分析-柱图
    StructuralAnaly: "/api/StructuralAnalysisCo/GetMyStructuralAnalysisCo",
    ////社会效益-总体概览
    MyGeneralOverview: "/api/GeneralOverview/GetMyGeneralOverview",
    //开放发展-地域分析http://101.200.237.184:8080/RegionalAnalysis/GetMyRegionalAnalysis  
    RegionalAnaly: "/api/RegionalAnalysis/GetMyRegionalAnalysis",
    //社会效益-结构分析http://101.200.237.184:8080/BenefitStructural/GetBenefitStructural
    BenefitStructur: "/api/BenefitStructural/GetBenefitStructural",
    //产业地图-基本信息
    CYTPStatus: "/api/StatusChartNew/GetMyCYTPStatusChartNew",
    //产业图谱-现状图-饼图http://101.200.237.184:8080/StatusChartCake/GetMyCYTPStatusChartCake
    CYTPStatusChartCake: "/api/StatusChartCake/GetMyCYTPStatusChartCake",
    //产业图谱-现状图-折线图http://101.200.237.184:8080/StatusChartLine/GetMyCYTPStatusChartLine
    CYTPStatusChartLine: "/api/StatusChartLine/GetMyCYTPStatusChartLine",
    //产业地图-信息列表http://101.200.237.184:8080/IndustryMapNew/GetMyIndustryMapNew
    IndustryMapNew: "/api/IndustryMapNew/GetMyIndustryMapNew",
    //市场主体-行业分析-着色下拉框（字典）/api/DataDict/GetListJson?DictType=ShadingType
    TocolorDatas:"/api/DataDict/GetListJson?DictType=ShadingType",
}  



// WEBPACK FOOTER //
// ./src/api/index.js